import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "专题", to: "/special/sp-01" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    setMenuOpen(false);
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:h-[68px] md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-play-fill text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              91av<span className="text-accent-600">视频</span>
            </span>
            <span className="mt-0.5 hidden text-[10px] tracking-[0.2em] text-foreground-500 md:block">
              MEDIA PORTAL
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="ml-auto hidden max-w-xs flex-1 md:flex">
          <div className="flex w-full items-center gap-2 rounded-full border border-background-300/70 bg-background-50 px-4 py-2 focus-within:border-primary-400">
            <i className="ri-search-line text-base text-foreground-500" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="search"
              placeholder="搜索影片、演员、题材"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
            />
            <button
              type="submit"
              className="shrink-0 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              搜索
            </button>
          </div>
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen(true)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-lg border border-background-300/70 text-foreground-800 lg:hidden"
        >
          <i className="ri-menu-line text-xl" />
        </button>
      </div>

      {menuOpen && (
        <div className="fixed inset-0 z-[60] flex flex-col bg-background-50 lg:hidden">
          <div className="flex h-16 items-center justify-between px-4">
            <span className="font-heading text-lg font-bold text-foreground-950">
              91av<span className="text-accent-600">视频</span>
            </span>
            <button
              type="button"
              aria-label="关闭菜单"
              onClick={() => setMenuOpen(false)}
              className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-300/70 text-foreground-800"
            >
              <i className="ri-close-line text-xl" />
            </button>
          </div>
          <div className="px-4 pb-2">
            <form onSubmit={handleSearch}>
              <div className="flex w-full items-center gap-2 rounded-full border border-background-300/70 bg-background-50 px-4 py-2.5">
                <i className="ri-search-line text-base text-foreground-500" />
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  type="search"
                  placeholder="搜索影片、演员、题材"
                  className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
                />
                <button
                  type="submit"
                  className="shrink-0 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50"
                >
                  搜索
                </button>
              </div>
            </form>
          </div>
          <nav className="flex flex-1 flex-col gap-1 overflow-y-auto px-4 py-4">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-lg px-4 py-3 text-base font-medium ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400" />
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}